import { useTranslation } from 'react-i18next';
import {
  DetailsList,
  Text,
  CommandBar,
  GroupHeader,
  SelectionMode,
} from 'office-ui-fabric-react';
import { useInteractions } from './InviteesList/utility/useInteractions';
import { commandBarItems } from './InviteesList/utility/getCommandBarItems';
import { columns } from './InviteesList/utility/getColumns';
import { useCustomSelection } from './InviteesList/utility/useCustomSelection';
import { DeleteInvitationSourcePanel } from './InviteesList/DeleteInvitationSourcePanel';
import { DeleteInvitationSourceMappingsPanel } from './InviteesList/DeleteInvitationSourceMappingsPanel';

const InviteesList = ({ hearingId, groups, items }) => {
  const { t: translator } = useTranslation();

  const {
    handleDeleteInvitationSourceMappingGroup,
    handleDeleteInvitationSourceMapping,
    handleDeleteInvitationSourceMappingsForUserOrCompany,
  } = useInteractions();

  const {
    isAnyGroupSelected,
    onGroupClick,
    isGroupSelected,
    selectedGroupName,
    setSelectedGroupName,
  } = useCustomSelection();

  const totalInvitees = items.length;

  return (
    <div className="invitees-list">
      <CommandBar
        items={commandBarItems(
          translator,
          handleDeleteInvitationSourceMappingGroup,
          isAnyGroupSelected(),
        )}
        className="invitees-command-bar"
        ariaLabel={translator(
          'pages.createHearing.createHearingInvitations.inviteesList.commandBarAriaLabel',
        )}
      />

      {totalInvitees > 0 ? (
        <div className="invitees-details-list" data-is-scrollable={true}>
          <DetailsList
            items={items}
            groups={groups}
            columns={columns(
              translator,
              handleDeleteInvitationSourceMapping,
              handleDeleteInvitationSourceMappingsForUserOrCompany,
            )}
            selectionMode={SelectionMode.none}
            ariaLabel={translator(
              'pages.createHearing.createHearingInvitations.inviteesList.detailsListAriaLabel',
            )}
            groupProps={{
              showEmptyGroups: true,
              onRenderHeader: (props) => {
                return (
                  <GroupHeader
                    {...props}
                    onGroupHeaderClick={(group) => onGroupClick(group.data)}
                    className={
                      isGroupSelected(props.group.data)
                        ? 'group-header--selected'
                        : 'group-header'
                    }
                  />
                );
              },
            }}
          />
        </div>
      ) : (
        <div className="no-invitees">
          <Text variant="medium">
            {translator(
              'pages.createHearing.createHearingInvitations.inviteesList.noInvitationsText',
            )}
          </Text>
        </div>
      )}
      <DeleteInvitationSourcePanel
        hearingId={hearingId}
        selectedGroupName={selectedGroupName}
        setSelectedGroupName={setSelectedGroupName}
      />
      <DeleteInvitationSourceMappingsPanel hearingId={hearingId} />
    </div>
  );
};

export { InviteesList };
